/* Mint-Cost-iPad › HĐ đối tác: 2 cột gap 14, thẻ padding 16 radius 18 gap 8. Màu chỉ var(--…). */
.grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 14px; }
.card { padding: 16px; border-radius: 18px; background: var(--card); box-shadow: var(--sh); display: flex; flex-direction: column; gap: 8px; }
.top { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; }
.no { font-weight: var(--fw-label); color: var(--link); }
.amt { font-size: 18px; font-weight: var(--fw-label); white-space: nowrap; }
.sub { font-size: 13px; color: var(--lb); }
.chips { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
.chip { padding: 3px 10px; border-radius: 999px; font-size: 13px; font-weight: var(--fw-label); }
.cOk { background: var(--ok-bg); color: var(--ok); }
.cWarn { background: var(--warn-bg); color: var(--warn); }
.cErr { background: var(--err-bg); color: var(--err); }
.mk { font-size: 13px; color: var(--tx2); }
.appr { font-size: 13px; font-weight: var(--fw-label); }
.act { align-self: flex-start; }
.row { display: flex; gap: 8px; flex-wrap: wrap; }
.bad { padding: 10px 12px; border-radius: 12px; background: var(--err-bg); color: var(--err); font-size: 13px; }
